import React from "react"
import { Button } from "@chakra-ui/react"
import { useConfigContext } from "@app/providers/config"

type Props = {
  denominationValues: Array<string>
  handleOption: (option: { name: string; value: string }) => void
  colours: string[]
  selectedDenomination: string | undefined
}

const DenominationOpts: React.FC<Props> = ({ denominationValues, handleOption, colours, selectedDenomination }) => {
  const {
    settings: { product },
  } = useConfigContext()
  return (
    <>
      {denominationValues.map((value: string, index: number) => (
        <Button
          variant="outline"
          key={`${value}-${index}`}
          fontSize="md"
          borderColor={colours[index]}
          bg={selectedDenomination === value ? colours[index] : "brand.white"}
          color={selectedDenomination === value ? "brand.white" : "brand.darkBlue"}
          _hover={{
            backgroundColor: colours[index],
            color: "primary.white",
          }}
          onClick={() => {
            handleOption({ name: product.denomination, value })
          }}
        >
          {value}
        </Button>
      ))}
    </>
  )
}

export default DenominationOpts
